import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { ProductComponent } from '../../SharedComponents'
import { product1Image, product2Image, product3Image } from '../../assets'

export default function ProductSection1() {
    return (
        <div>
            <Row className='product-section-1 mx-0'>
                <Col md={4}>
                    <ProductComponent title='Marine Plywood' image={product1Image} /> </Col>
                <Col md={4} className='mt-5 pt-5 pt-md-0 mt-md-0'>
                    <ProductComponent title='Boiling Water Resistant Plywood' image={product2Image} />
                </Col>
                <Col md={4} className='mt-5 pt-5 pt-md-0 mt-md-0'>
                    <ProductComponent title='Moisture Resistant Plywood' image={product3Image} />
                </Col>
            </Row>
            <div className='bg'></div>
        </div>
    )
}
